import icon1 from '../images/icon/research.gif'
import icon2 from '../images/icon/durability.gif'
import icon3 from '../images/icon/digital-tra.gif'
import icon4 from '../images/icon/business-develop.gif'
import icon5 from '../images/icon/search.gif'
import icon6 from '../images/icon/warning.gif'

import sicon1 from '../images/icon/ser-icon01.svg'
import sicon2 from '../images/icon/ser-icon02.svg'
import sicon3 from '../images/icon/ser-icon03.svg'
import sicon4 from '../images/icon/ser-icon04.svg'

import sdicon1 from '../images/icon/da-fea_icon01.svg'
import sdicon2 from '../images/icon/da-fea_icon02.svg'
import sdicon3 from '../images/icon/da-fea_icon03.svg'
import sdicon4 from '../images/icon/da-fea_icon04.svg'

import simg1 from '../images/service/service-img02.jpg'
import simg2 from '../images/service/service-img01.jpg'
import simg3 from '../images/service/service-img03.jpg'
import simg4 from '../images/service/service-img04.jpg'

import scicon1 from '../images/icon/airdrop-white.svg'
import scicon2 from '../images/icon/cloud-add.svg'
import scicon3 from '../images/icon/check02.svg'
import scicon4 from '../images/icon/finger-scan.svg'
import scicon5 from '../images/icon/ranking.svg'

import cdicon1 from '../images/icon/cd-ser_icon01.svg'
import cdicon2 from '../images/icon/cd-ser_icon02.svg'
import cdicon3 from '../images/icon/cd-ser_icon03.svg'
import cdicon4 from '../images/icon/cd-ser_icon04.svg'
import cdicon5 from '../images/icon/cd-ser_icon05.svg'
import cdicon6 from '../images/icon/cd-ser_icon06.svg'
import cdicon7 from '../images/icon/cd-ser_icon08.svg'
import cdicon8 from '../images/icon/cd-ser_icon09.svg'

const Services = [
    {
        Id: '1',
        sImg: icon1,
        title: 'Odoo E-Commerce Integration',
        slug: 'Odoo-Ecommerce',
        thumb1: 'Shopify',
        thumb2: 'Magento',
        description: 'Seamless integration between Odoo and Shopify or Magento for unified inventory, sales, and accounting.',
    },
    {
        Id: '2',
        sImg: icon2,
        title: 'Headless Magento Development',
        slug: 'Headless-Magento',
        thumb1: 'API',
        thumb2: 'GraphQL',
        description: 'Build fast, headless Magento storefronts connected to Odoo backend for real-time order and stock sync.',
    },
    {
        Id: '3',
        sImg: icon3,
        title: 'Mobile App for Odoo ERP',
        slug: 'Odoo-Mobile-App',
        thumb1: 'React Native',
        thumb2: 'Flutter',
        description: 'Custom mobile apps for Odoo — manage sales, POS, inventory, and CRM from anywhere with full synchronization.',
    },
    {
        Id: '4',
        sImg: icon4,
        title: 'Odoo Manufacturing (MRP)',
        slug: 'Odoo-Manufacturing',
        thumb1: 'Automation',
        thumb2: 'Production',
        description: 'Digitize your production process with Odoo Manufacturing — real-time work orders, routing, and efficiency tracking.',
    },
    {
        Id: '5',
        sImg: icon5,
        title: 'Odoo Inventory Management',
        slug: 'Odoo-Inventory',
        thumb1: 'Warehouse',
        thumb2: 'Logistics',
        description: 'End-to-end warehouse control — manage stock, barcode operations, and multi-warehouse transfers in Odoo.',
    },
    {
        Id: '6',
        sImg: icon6,
        title: 'Odoo POS & Retail Suite',
        slug: 'Odoo-POS',
        description: 'Smart Odoo POS with offline mode, real-time sync to accounting, loyalty programs, and multi-store management.',
    },
    {
        Id: '7',
        sImg: simg1,
        sIcon: sicon1,
        title: 'Odoo ERP Implementation',
        slug: 'Odoo-ERP-Implementation',
    },
    {
        Id: '8',
        sImg: simg2,
        sIcon: sicon2,
        title: 'Odoo Customization & Modules',
        slug: 'Odoo-Customization-&-Modules',
    },
    {
        Id: '9',
        sImg: simg3,
        sIcon: sicon3,
        title: 'Odoo-Shopify Bridge',
        slug: 'Odoo-Shopify-Bridge',
    },
    {
        Id: '10',
        sImg: simg4,
        sIcon: sicon4,
        title: 'Odoo-Magento Bridge',
        slug: 'Odoo-Magento-Bridge',
    },
    {
        Id: '11',
        sIcon: sdicon1,
        title: 'Data Migration & Upgrade',
        slug: 'Data-Migration-&-Upgrade',
        description: 'Upgrade from legacy systems or older Odoo versions with secure data migration and zero downtime.',
    },
    {
        Id: '12',
        sIcon: sdicon2,
        title: 'Odoo Integration API Setup',
        slug: 'Odoo-Integration-API-Setup',
        description: 'We design custom APIs and connectors to integrate Odoo with your business ecosystem.',
    },
    {
        Id: '13',
        sIcon: sdicon3,
        title: 'Odoo Automation & AI',
        slug: 'Odoo-Automation-&-AI',
        description: 'Automate operations with Odoo workflows, AI insights, and real-time performance analytics.',
    },
    {
        Id: '14',
        sIcon: sdicon4,
        title: 'Functional & Technical Training',
        slug: 'Functional-&-Technical-Training',
        description: 'Comprehensive Odoo training for teams to master daily operations, reports, and configurations.',
    },
    {
        Id: '15',
        sIcon: scicon1,
        title: 'Odoo Cloud Deployment',
        slug: 'Odoo-Cloud-Deployment',
        features: ['Odoo.sh setup & optimization', 'Cloud hosting with SSL', '24×7 monitoring', 'Database backup automation', 'Scalable cloud instances']
    },
    {
        Id: '16',
        sIcon: scicon2,
        title: 'Server & Security Management',
        slug: 'Server-&-Security-Management',
        features: ['Firewall and SSL setup', 'Database tuning', 'Uptime monitoring', 'Regular patch updates', 'Data encryption']
    },
    {
        id: '17',
        sIcon: scicon3,
        title: 'QA & Performance Testing',
        slug: 'QA-&-Performance-Testing',
        features: ['Load testing', 'Module validation', 'API performance checks', 'Speed optimization', 'User experience testing'],
    },
    {
        id: '18',
        sIcon: scicon4,
        title: 'Odoo Data Consistency',
        slug: 'Odoo-Data-Consistency',
        features: [
            "Real-time sync between Odoo & eCommerce.",
            "Prevent duplicate or missing records.",
            "Auto-validation of financial entries.",
            "Multi-warehouse stock accuracy.",
            "Seamless audit and reporting."
        ],
    },
    {
        id: '19',
        sIcon: scicon5,
        title: 'Industry-Specific ERP Solutions',
        slug: 'Industry-Specific-ERP-Solutions',
        features: [
            'Manufacturing & MRP',
            'Retail & POS',
            'Wholesale & Distribution',
            'Education & Healthcare',
            'Service & Finance'
        ],
    },

    {
        Id: '20',
        sIcon: cdicon1,
        title: 'ERP Infrastructure Design',
        slug: 'ERP-Infrastructure-Design',
    },
    {
        Id: '21',
        sIcon: cdicon2,
        title: 'Cost Optimization Strategy',
        slug: 'Cost-Optimization-Strategy',
        bgClass:'cd-dot_bg2',
    },
    {
        Id: '22',
        sIcon: cdicon3,
        title: 'Odoo as a Service (OaaS)',
        slug: 'Odoo-as-a-Service',
        bgClass:'cd-dot_bg3',
    },
    {
        Id: '23',
        sIcon: cdicon4,
        title: 'Continuous Integration',
        slug: 'Continuous-Integration',
        bgClass:'cd-dot_bg4',
    },
    {
        Id: '24',
        sIcon: cdicon5,
        title: 'Continuous Deployment',
        slug: 'Continuous-Deployment',
    },
    {
        Id: '25',
        sIcon: cdicon6,
        title: 'Multi-Company Deployment',
        slug: 'Multi-Company-Deployment',
        bgClass:'cd-dot_bg2',
    },
    {
        Id: '26',
        sIcon: '',
        title: 'Data Reliability',
        slug: 'Data-Reliability',
        bgClass:'cd-dot_bg3'
    },
    {
        Id: '27',
        sIcon: cdicon7,
        title: 'Database Integrity & Auditing',
        slug: 'Database-Integrity-&-Auditing',
        bgClass:'cd-dot_bg4'
    },
    {
        Id: '28',
        sIcon: cdicon8,
        title: 'Backup & Redundancy System',
        slug: 'Backup-&-Redundancy-System',
    },
]

export default Services;
